import { LOAD_PROJECT, FETCH_LINKS, FETCH_LINK, CREATE_LINK, UPDATE_LINK, DESTROY_LINK, REMOVE_LINK_PIXEL_SET, LOGOUT } from '../actions/actionTypes.js';
import { keyBy, omit } from 'lodash';

const initialState = {}

export const links = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LINKS.SUCCESS:
      return keyBy(action.payload.links || [], 'id');
    case LOAD_PROJECT.START:
    case FETCH_LINKS.UNLOAD:
      return initialState;
    case CREATE_LINK.SUCCESS:
    case UPDATE_LINK.SUCCESS:
    case FETCH_LINK.SUCCESS:
    case REMOVE_LINK_PIXEL_SET.SUCCESS:
      return {
        ...state,
        [action.payload.id]: action.payload
      };
    case FETCH_LINK.START:
      if (!action.payload || !action.payload.id)
        return state
      
      return {
        ...state,
        [action.payload.id]: {...(state[action.payload.id] || {}), loading:true}
      }
    case FETCH_LINK.FAIL:
      if (!action.data || !action.data.id)
        return state
      
      return {
        ...state,
        [action.data.id]: {...(state[action.payload.id] || {}), error:true, message: action.payload.message, loading:false}
      }
    case DESTROY_LINK.SUCCESS:
      return omit(state, action.payload.id);
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/links.js